<template>
  <div>
    <p style="margin-top:20%; text-align: center">银联分期支付成功，课程已开通！</p>
  </div>
</template>

<script>
export default {
  name: 'unionpayInstallmentFinished',
  data() {
    return {
      hasReceived: false,
      clientWidth: document.documentElement.clientWidth,
      clientHeight: document.documentElement.clientHeight,
    };
  },
  created() {
    this.hideIframe();
  },
  methods: {
    hideIframe() {
      const sessionUrl = window.sessionStorage.getItem('unionPayInstallmentReturnUrl');
      if (sessionUrl) {
        window.sessionStorage.removeItem('unionPayInstallmentReturnUrl');
        window.location.href = sessionUrl;
      }
    }
  }
};
</script>

<style scoped>
</style>
